import { render } from "./PlanoPagamento.vue?vue&type=template&id=1d46c885&scoped=true"
import script from "./PlanoPagamento.vue?vue&type=script&lang=js"
export * from "./PlanoPagamento.vue?vue&type=script&lang=js"

import "./PlanoPagamento.vue?vue&type=style&index=0&id=1d46c885&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d46c885"]])

export default __exports__